export default __webpack_public_path__ + "assets/images/bdfdc2f3bc6980df6dff24c07199507a.png";